import React from 'react'

import GoogleMapReact from 'google-map-react'
import { fitBounds } from 'google-map-react/utils'

class Map extends React.Component {
  constructor(props) {
    super(props)
    this.markers = {}
  }

  handleOnClickOnMarker = (photoId) => {
    console.log('handleOnClickMarker:', photoId)
    this.props.onClickOnMarker(photoId)
    //this.addMarkerAnimation(photoId);
  }

  removeAllMarkerAnimation = () => {
    Object.values(this.markers).forEach((m) => m.setAnimation(null))
  }

  addMarkerAnimation = (photoId) => {
    this.removeAllMarkerAnimation()
    let marker = this.markers[photoId]
    if (marker) {
      marker.setAnimation(this.maps.Animation.BOUNCE)
    }
  }

  handleApiLoaded = (map, maps) => {
    this.map = map
    this.maps = maps
    this.map.fitBounds(this.bounds)
    this.addMarkers()
  }

  getBounds(files) {
    var bounds = {}
    var minlat = 0
    var maxlat = 0
    var minlng = 0
    var maxlng = 0
    var bfirst = true
    for (var i = 0; i < files.length; i++) {
      var f = files[i]
      console.log('getBounds: file =' + JSON.stringify(f))
      if (f.lat && f.lng) {
        if (bfirst) {
          minlat = f.lat
          maxlat = f.lat
          minlng = f.lng
          maxlng = f.lng
          bfirst = false
        } else {
          if (minlat > f.lat) {
            minlat = f.lat
          }
          if (maxlat < f.lat) {
            maxlat = f.lat
          }
          if (minlng > f.lng) {
            minlng = f.lng
          }
          if (maxlng < f.lng) {
            maxlng = f.lng
          }
        }
      }
    }

    var offset = 0.05
    bounds.north = maxlat + offset
    bounds.south = minlat - offset
    bounds.east = maxlng + offset
    bounds.west = minlng - offset
    console.log('bounds=' + JSON.stringify(bounds))
    return bounds
  }

  addMarkers = () => {
    if (!this.maps) return
    const files = this.props.photos
    const _map = this
    for (var i = 0; i < files.length; i++) {
      var file = files[i]
      if (file.lat && file.lng) {
        console.log('adding marker...')

        var marker = new this.maps.Marker({
          position: { lat: file.lat, lng: file.lng },
          map: this.map,
        })

        this.markers[file._id] = marker
        marker.fileId = file._id
        marker.addListener('click', function (e) {
          console.log('on click marker:', e, this.fileId)
          _map.handleOnClickOnMarker(this.fileId)
        })
      }
    }
  }

  getMapOptions = (maps) => {
    return {
      mapTypeControl: true,
      mapTypeId: maps.MapTypeId.TERRAIN,
      mapTypeControlOptions: {
        style: maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: maps.ControlPosition.TOP_CENTER,
        mapTypeIds: [
          maps.MapTypeId.ROADMAP,
          maps.MapTypeId.SATELLITE,
          maps.MapTypeId.HYBRID,
          maps.MapTypeId.TERRAIN,
        ],
      },
      scaleControl: true,
    }
  }

  render() {
    this.bounds = this.getBounds(this.props.photos)
    this.addMarkers()
    return (
      <div style={{ height: '450px', width: '450px' }}>
        <GoogleMapReact
          key={'map_' + this.props.folderId}
          bootstrapURLKeys={{ key: 'AIzaSyDAweNSvuCA2eRhY6edLPMZfezfCSo1bfg' }}
          center={{ lat: this.bounds.north, lng: this.bounds.east }}
          zoom={4}
          resetBoundsOnResize={true}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => this.handleApiLoaded(map, maps)}
          options={this.getMapOptions}
        ></GoogleMapReact>
      </div>
    )
  }
}

export default Map
